
<template>
  <!--添加房间-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect, userRange } from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'addRoom',
  data () {
    function validateArea (rule, value, callback) {
      let bitNum = 0;
      let str = String(value);
      if (str && str.includes('.')) {
        bitNum = str.split('.')[1].length;
      }
      if (value && parseFloat(value) <= 0) {
        callback(new Error('建筑面积需大于0'));
      } else if (bitNum > 2) {
        callback(new Error('最多两位小数'));
      } else {
        callback();
      }
    }
    let decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      buildingId: {
        rules: [{ required: true, message: '请选择所属楼栋' }]
      },
      unitId: {
        rules: [{ required: true, message: '请选择所属单元' }]
      },
      roomNo: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入房间号' },
          { min: 4, max: 4, message: '房间号为4位数' }
        ]
      },
      buildingArea: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入建筑面积'},
          { validator: validateArea }
        ]
      }
    };
    return {
      cascadeParam: {
        communityId: '',
        buildingId: ''
      },
      formKey: {
        communityId: '',
        buildingId: '',
        unitId: '',
        roomNo: '',
        buildingArea: '',
        type: ''
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          handle: e => {
            this.communityChange(1, e, 'formList');
            this.$refs.addEdit.resetSubValue(['buildingId', 'unitId'], e);
          },
          placeholder: '请选择小区',
          fetchOptions: this.getOptions,
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          handle: e => {
            this.buildingChange(2, e, 'formList');
            this.$refs.addEdit.resetSubValue('unitId', e);
          },
          placeholder: '请选择楼栋',
          props: ['buildingId', decoratorOptions.buildingId]
        },
        {
          label: '所属单元',
          inputType: 'select',
          options: [],
          placeholder: '请选择单元',
          props: ['unitId', decoratorOptions.unitId]
        },
        {
          label: '房间号',
          inputType: 'input',
          options: [],
          placeholder: '请输入房间号',
          type: 'number',
          props: ['roomNo', decoratorOptions.roomNo]
        },
        {
          label: '建筑面积',
          inputType: 'input',
          options: [],
          placeholder: '请输入建筑面积',
          type: 'number',
          props: ['buildingArea', decoratorOptions.buildingArea]
        },
        {
          label: '住宅类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择住宅类型',
          props: ['type', {
            rules: [{required: true, message: '请选择住宅类型'}]
          }]
        }
      ],
      addParam: {
        url: '/room',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/room/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/room/',
        resHandle: this.detailResHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, '0', item.communityId);
    },
    /* 获取下拉 */
    getSelect () {
      // this.communitySelect(0, 'formList', 1);
      this.communitySelectByStep(1, undefined, undefined, '0');
      this.dictionarySelect([{index: 5, scope: 'formList', query: 'comu_room_type'}]);
    },
    detailResHandle (res) {
      let arr = this.formList[0].options;
      this.formList[0].communityId = res.communityId;
      this.communitySelectByStep(1, undefined, undefined, '0', res.communityId);
      this.limitEdit(res, ['communityId', 'buildingId', 'unitId']);
      res.communityId && this.communityChange(1, res.communityId, 'formList');
      res.buildingId && this.buildingChange(2, res.buildingId, 'formList');
      return {};
    }
  }
};
</script>
